(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ChartStatusHistory', ChartStatusHistory);

    ChartStatusHistory.$inject = ['$resource', 'DateUtils'];

    function ChartStatusHistory ($resource, DateUtils) {
        var resourceUrl =  'api/chart-status-histories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();
